import jqgrid from './angular-jqgrid-stable';
import './obto-data-service';

import './ng-file-upload.min';
// import * as React from "react";
import async from "async";
// import * as moment from "moment-timezone";
import * as _ from "underscore";
// import GridRenderer from './GridRenderer';
import * as feather from "feather-icons";
// import { render } from 'react-dom';
import { react2angular } from 'react2angular';
import JQGridReact from './components/JQGridReact';
import React from 'react';
// import { AgGridReact } from 'ag-grid-react';
// import {AutocompleteSelectCellEditor} from 'ag-grid-autocomplete-editor';
// import 'ag-grid-autocomplete-editor/main.css';
// import React, { useState } from 'react';
// import 'ag-grid-community/styles/ag-grid.css';
// import 'ag-grid-community/styles/ag-theme-alpine.css';
// import * as agGrid from 'ag-grid-enterprise/dist/ag-grid-enterprise.min';
// agGrid.LicenseManager.setLicenseKey("MjAwMDAwMDAwMDAwMA==598447838c89eb4366146127615e4");
// agGrid.initialiseAgGridWithAngular1(angular);

export default angular.module('obto.data.jqgrid', [
    // 'agGrid',
    'jqgrid',
    'obto.data.service',
])
    .component('jqGridReact', react2angular(JQGridReact, [
        'table',
        'domain',
        'columnModel',
        'filterData',
        'gridOptions',
        'search',
        'parentdiv',
        'open',
        'filter'
    ]))
    .controller('JQController', ['$scope', '$route', '$log', '$http', '_', '$rootScope', '$routeParams', 'pageService', '$uibModal', 'moment', '$timeout', '$window', '$location', '$ngRedux', '$localstorage', 'OB', 'API', 'CS',
        function ($scope, $route, $log, $http, _, $rootScope, $routeParams, pageService, $uibModal, moment, $timeout, $window, $location, $ngRedux, $localstorage, OB, API, CS) {
            $scope.BreadCrums = [];
            $scope.filterData = {};
            $scope.list_query = "";
            $scope.query_object = {};
            $scope.values = { "table": $routeParams.collection };
            $scope.requestQueryParams = "";
            $scope.parentDivId = 'genericlistview';
            $scope.title = "List View";
            $scope.Filters = [];
            $scope.filterController = {};
            const contextMenuItens = {
                "edit": {
                    name: "Edit",
                    icon: "fa-pencil"
                }
            };
            $.contextMenu('destroy', 'button.editable-actions');
            $.contextMenu({
                selector: 'button.editable-actions',
                callback: function (key, options, event) {
                    console.log(event.$trigger[0]);
                    console.log(event.$trigger[0].id);
                    // console.log($(event.$trigger).parent()[0].id);
                    // console.log($('#' + event.$trigger[0].id).closest('td').attr('aria-describedby'));
                    console.log('options', options);

                    const rowUri = event.$trigger[0].collection + "/" + event.$trigger[0].id;//table.jqGrid("getCell", currentRowId, "_id");
                    if (options === 'edit') {
                        location.href = rowUri;
                    }

                },
                items: contextMenuItens
            });
            const o = {
                root: $rootScope,
                scope: $scope,
                timeout: $timeout,
                http: $http,
                window: $window,
                moment: moment,
                _: _,
                routeParams: $routeParams,
                location: $location,
                API: API,
                localStorage: $localstorage,
                service: OB,
                async: async,
                M: CS,
            };
            $scope.gridOptions = {
                gridHeight: '63vh'
            };

            $scope.print = function () {
                let table = document.getElementById($scope.parentDivId).innerHTML;
                let myWindow = window.open('', '', 'width=800, height=600');
                myWindow.document.write(table);
                myWindow.print();
            };
            const restrictedKeys = ['_search', 'nd', 'rows', 'page', 'sidx', 'sord', 'project'];

            const deregister1 = $scope.$watch("filterData", function () {
                $scope.requestQuery();
            }, true);

            $scope.removeFilter = (filter) => {
                $scope.filterController.run(filter.el);
                const deleteIndex = $scope.BreadCrums.findIndex(val => val.name === filter.el.toUpperCase());
                $scope.BreadCrums.splice(deleteIndex, 1);
                $scope.BreadCrums.splice(deleteIndex, 1);
                console.log('$scope.BreadCrums', $scope.BreadCrums);
            };

            $scope.errorFlag = false;

            const deregister2 = $scope.$watch("query_object", function () {
                console.log($scope.query_object);
                const filterData = {};
                if ($scope.query_object && $scope.query_object.collection && $scope.query_object.collection !== "null") {
                    filterData['m_query'] = $scope.query_object.collection;
                }
                $scope.filterData = filterData;
            }, true);

            const deregister3 = $rootScope.$watch("message", function () {
                if (!_.isUndefined($rootScope.message) && $rootScope.message.length !== 0) {
                    $rootScope.message = "";
                } else {
                    $rootScope.message = "";
                    $scope.errorFlag = false;
                }

            }, true);

            $scope.refresh = (filter = {}) => {
                console.log('==>>event:grid:refresh' + $scope.parentDivId);
                //set filter active in UI
                const Filters = $scope.Filters;
                let active = false;
                if (filter.active) {
                    active = false;
                    $rootScope.$broadcast('event:grid:remove:filter' + $scope.parentDivId, filter.filter);
                } else {
                    active = true;
                    $rootScope.$broadcast('event:grid:refresh' + $scope.parentDivId, filter.filter);
                }

                Filters.map(val => {
                    if (val.name === filter.name) {
                        val.active = active;
                    }
                    return val;
                });
                $scope.Filters = Filters;
                // console.log('$scope.Filters', $scope.Filters);
                feather.replace({
                    width: 24,
                    height: 24,
                });
            };

            $scope.requestQuery = function () {
                if (typeof $scope.filterData === "object") {
                    $scope.requestQueryParams = Object.keys($scope.filterData).map(key => key + '=' + encodeURIComponent($scope.filterData[key])).join('&');
                }
                // console.log($scope.requestQueryParams);
            };

            let routparams = $routeParams;
            $scope.columnName = [];
            $scope.collection = $routeParams.collection;
            const _collectionName = $routeParams.collection;

            $scope.view_schema = () => {
                $log.info($scope.collection);
                $location.url(`/pltf_field/list?_search&nd=${new Date().getTime()}&rows=25&page=1&sidx=updated_on&sord=desc&project=updated_on,name,section_name,default_value,collection_name,list_order,label,input_type,refer_collection,dependency,row_id,display_field,map,column_id,form_view,readonly,mandatory,list_view,app,source_filter,domain,_id,domain&collection_name=${$scope.collection}`);
            };

            $scope.view_policies = () => {
                $log.info($scope.collection);
                const _url = `/pltf_policy_server/list?_search=true&nd=${new Date().getTime()}&rows=25&page=1&sidx=updated_on&sord=desc&project=name,active,action,collection,execution_time,order,domain,script,created_on,created_by,version,app,_id,domain&collection=${$scope.collection}`;
                $location.url(_url);
                // $location.search('collection', $scope.collection);
            };

            $scope.view_client_policies = () => {
                $log.info($scope.collection);
                const _url = `/pltf_policy_client/list?_search=true&nd=${new Date().getTime()}&rows=25&page=1&sidx=updated_on&sord=desc&project=name,active,action,collection,execution_time,order,domain,script,created_on,created_by,version,app,_id,domain&collection=${$scope.collection}`;
                $location.url(_url);
            };

            delete routparams.collection;
            $scope.queryparams = routparams;
            $scope.displayCollection = $scope.collection.replace("_", " ");
            $scope.jqgridContainer = "jqgridContainer";

            if (routparams.obupload === "1") {
                $scope.open('upload.html', 'lg');
            }
            let str = $scope.displayCollection;
            $scope.displayCollection = str.substring(0, 1).toLocaleUpperCase() + str.substring(1);

            $scope.domain = $rootScope.domain;

            $scope.open = function (name, aggregate, size, params) {

                let modalInstance = $uibModal.open({
                    templateUrl: name,
                    animation: false,
                    controller: 'ModalInstanceCtrl2',
                    size: size || 'lg',
                    resolve: {
                        commons: function () {
                            return { collection: $scope.collection, _csrf: null, name: name };
                        },
                        aggregate: function () {
                            return aggregate || null;
                        },
                        params: function () {
                            return params || null;
                        }
                    }
                });

                modalInstance.result.then(function (selectedItem) {
                    //$scope.selected = selectedItem;
                }, function () {
                    $log.info('Modal dismissed at: ' + new Date());
                });

                if (name === "mapupdate.html")
                    return modalInstance;

                if (name === "updaterecord.html")
                    modalInstance.close();//$timeout(modalInstance.close(), 100);
            };

            const saveFile = (name, type, data) => {
                if (data !== null && navigator.msSaveBlob)
                    return navigator.msSaveBlob(new Blob([data], { type: type }), name);
                let a = $("<a style='display: none;'/>");
                let url = window.URL.createObjectURL(new Blob([data], { type: type }));
                a.attr("href", url);
                a.attr("download", name);
                $("body").append(a);
                a[0].click();
                window.URL.revokeObjectURL(url);
                a.remove();
            };

            const jsonView = () => {

                let jsonViewCb = (response) => {

                    "use strict";
                    let file = new Blob([response.data], {
                        type: 'application/json'
                    });

                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(file); // for IE
                    } else {
                        window.open(URL.createObjectURL(file));
                    }


                };
                $http.get('/jsonview/' + $scope.collection + '?' + $scope.requestQueryParams, {
                    responseType: "arraybuffer"
                }).then(jsonViewCb);

            };

            const pdfView = () => {
                "use strict";

            };

            const jsonDownload = (omitId = false, omitTs = false) => {
                const jsonCb = (response) => {
                    // swal("Success", "Your file should be downloading momentarily...", "success");
                    saveFile($scope.collection + ".json", "data:attachment/json", response.data);
                };

                swal({
                    title: "Are you sure?",
                    text: "You gotta do what you gotta do",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Yes, download it!",
                    cancelButtonText: "No, cancel plz!"
                }).then((result) => {
                    if (result.value) {
                        $http.get(`/jsonexport/${$scope.collection}?omitId=${omitId}&omitTs=${omitTs}&${$scope.requestQueryParams}`, {
                            responseType: "arraybuffer"
                        }).then(jsonCb);
                        swal("Success", "Your file is open right next window :)", "success");
                    } else {
                        swal("Cancelled", "Your imaginary file is safe :)", "error");
                    }
                });


            };

            const csvDownload = () => {

                "use strict";
                swal({
                    title: "Are you sure?",
                    text: "You gotta do what you gotta do",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Yes, download it!",
                    cancelButtonText: "No, cancel plz!"
                }).then((result) => {
                    if (result.value) {
                        export_table_to_csv('jqgrid-table-0', 'csv', $scope.displayCollection + ".csv");
                        swal("Success", "Your file is open right next window :)", "success");
                    } else {
                        swal("Cancelled", "Your imaginary file is safe :)", "error");
                    }
                });

            };

            const excelDownload = () => {

                "use strict";
                let xlsCB = (response) => {
                    saveFile($scope.collection + ".xlsx", "data:attachment/vnd.openxmlformats-officedocument.spreadsheetml.sheet", response.data);
                };
                swal({
                    title: "Are you sure?",
                    text: "You gotta do what you gotta do",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Yes, download it!",
                    cancelButtonText: "No, cancel plz!"
                }).then((result) => {
                    if (result.value) {
                        // console.log('$scope.requestQueryParams', $scope.requestQueryParams);
                        $http.get('/xlsx/' + $scope.collection + '?' + $scope.requestQueryParams, {
                            responseType: "arraybuffer"
                        }).then(xlsCB);
                        swal("Success", "Your file is open right next window :)", "success");
                    } else {
                        swal("Cancelled", "Your imaginary file is safe :)", "error");
                    }
                });
            };

            $scope.actions = {
                jsonView: jsonView,
                pdfView: pdfView,
                excelDownload: excelDownload,
                jsonDownload: jsonDownload,
                csvDownload: csvDownload
            };

            feather.replace({
                width: 24,
                height: 24,
            });

            $scope.actionVisible = {};
            const deregister5 = $ngRedux.subscribe(() => {
                let state = $ngRedux.getState();
                if (state.appState.lists && state.appState.lists[$scope.collection]) {
                    const Filters = state.appState.lists[$scope.collection].Filters || [];
                    Filters.map(val => {
                        if (val.filter && typeof val.filter === "string") {
                            val.filter = JSON.parse(val.filter.replace(/&quot;/g, '"'));
                        }
                        return val;
                    });
                    $scope.Filters = Filters;
                    const ui_actions = state.appState.lists[$scope.collection].Actions || [];
                    const actionVisible = {};
                    $log.debug("ui_actions", ui_actions);
                    ui_actions.map(val => {
                        const USE_SCRIPT = (val.compiled) ? val.compiled.code : val.handler;
                        actionVisible[val._id] = false;
                        val.handler = () => {
                            new Function(`try { ${USE_SCRIPT} return _func(); } catch(err) { console.log(${val.name}, err)}`)()(o);
                        };

                        if (val.condition) {
                            // const field_values = on_change ? $scope.modifiedFieldValue : $scope.values;
                            try {
                                actionVisible[val._id] = new Function(`try { ${val.condition} } catch(err) { console.log(${val.name}, err)}`)()(o, {});
                                $log.debug("actionVisible", actionVisible);
                            } catch (e) {
                                // throw e;
                                $log.error(e);
                            }
                        }
                        return val;
                    });
                    $scope.Actions = ui_actions;
                    $scope.actionVisible = Object.assign($scope.actionVisible, actionVisible);
                }
            });

            const deregister4 = $scope.$on('$destroy', () => {
                deregister1();
                deregister2();
                deregister3();
                deregister4();
                deregister5();
                $log.info('Removed all list listeners');
            });

        }])
    .controller('ModalInstanceCtrl2', ['$uibModalInstance', '$scope', '$timeout', '$http', '$log', '$location', '_', 'API', 'commons', 'aggregate', 'params', function ($uibModalInstance, $scope, $timeout, $http, $log, $location, _, API, commons, aggregate, params) {

        let errCallback = function (data, status, headers, config) {

        };

        $scope.uploadincollection = false;
        $scope.acceptedFiles = "";
        $scope.collection = commons.collection;
        $scope.uploadValidation = {
            user_fields: [],
            template_fields: [],
            template: "",
            problemFields: []
        };

        $scope.action = {
            localstore: true,
            custom: false
        };

        if (commons.name === "upload.html") {

        }

        $scope.$watch("uploadincollection", (n, o) => {
            if (n === true) {
                $scope.acceptedFiles = ".js,.css";
            } else {
                $scope.acceptedFiles = "";
            }
        });

        $scope.action.showalbum = false;

        $scope.$watch("action.localstore", function (n, o) {
            console.log(n);
            if (commons.collection === "image") {
                $scope.action.custom = !$scope.action.localstore;
            }
        });

        if (commons.collection === "image") {
            $scope.action.showalbum = true;
            $scope.action.localstore = true;
            $scope.action.custom = false;
        }

        $scope.dynamic = 100;
        $scope.collection = commons.collection;
        $scope.existingFiles = {};

        $scope.error = "";

        $scope.ok = function () {
            // $location.search('obupload', null);
            $uibModalInstance.close({});
        };

        $scope.cancel = function () {
            // $location.search('obupload', null);
            $uibModalInstance.dismiss('cancel');
        };

        // if (!_.isUndefined(aggregate) && aggregate !== null) {
        //
        //     let _url = "/o/recs/pltf_visualization?oquery=name=simple_line_chart&stream=true";
        //     let groupBy = aggregate.groupBy;
        //     $scope.chartType = "-";
        //     $scope.aggregationField = "-";
        //     $scope.aggregationType = "-";
        //     $scope.canDisplay = true;
        //
        //     let newAggregation = {
        //         "script": {
        //             "match": aggregate.query,
        //             "group": {
        //                 "y": {
        //                     "avg": "$score"
        //                 }
        //             },
        //             "project": {
        //                 "name": "$_id." + groupBy,
        //                 "y": "$y",
        //                 "url": {
        //                     "$literal": "/o/#/" + commons.collection + "/list"
        //                 },
        //                 "_id": 0
        //             },
        //             "sort": {
        //                 "name": 1
        //             }
        //         },
        //         "_csrf": aggregate._csrf,
        //         "color": "",
        //         "label": $scope.aggregationField
        //     };
        //
        //     $scope.$watch("chartType", function (n) {
        //
        //         if ($scope.chartType !== "-") {
        //             $scope.visualizeConfig = {};
        //             _url = "/o/recs/pltf_visualization?oquery=name=simple_line_chart&stream=true";
        //             if ($scope.chartType === "bar") {
        //                 _url = "/o/recs/pltf_visualization?oquery=name=simple_bar_chart&stream=true";
        //             }
        //             $scope.canDisplay = true;
        //             //console.log("Chart type selected:" + n);
        //             var request = $http({
        //                 method: "get",
        //                 url: _url,
        //                 //transformRequest: transformRequestAsFormPost,
        //                 data: {}
        //             });
        //
        //             // Store the data-dump of the FORM scope.
        //             request.success(
        //                 function (response) {
        //                     $log.log("Response : " + JSON.stringify(response));
        //                     //console.log(typeof response[0].script);
        //
        //                     $scope.visualizeConfig = JSON.parse(response[0].script);
        //                     $log.log("Response : " + JSON.stringify(JSON.parse(response[0].script)));
        //                     $scope.visualizeConfig.options.xAxis.title.text = groupBy;
        //                     $scope.visualizeConfig.options.xAxis.categories.push();
        //                     $scope.visualizeConfig.options.yAxis.title.text = $scope.aggregationField;
        //                     $scope.visualizeConfig.options.title.text = "Subject Performance";
        //                     $scope.$broadcast('highchartsng.reflow');
        //                 });
        //
        //             request.error(errCallback);
        //         }
        //     });
        //
        //     newAggregation.script.group._id = {};
        //
        //     newAggregation.script.group._id[groupBy] = "$" + groupBy;
        //
        //     $scope.$watch("aggregationType", function (n) {
        //         if ($scope.aggregationType !== "-") {
        //             $scope.canDisplay = true;
        //             newAggregation.script.group.y[n] = "$" + $scope.aggregationField;
        //         }
        //     });
        //
        //     $scope.$watch("aggregationField", function (n) {
        //         if ($scope.aggregationType !== "-") {
        //             $scope.canDisplay = true;
        //             //console.log("Aggregation type selected:" + n);
        //             newAggregation.script.group.y[$scope.aggregationType] = "$" + n;
        //             newAggregation.label = $scope.aggregationField;
        //
        //             var request = $http({
        //                 method: "post",
        //                 url: "/o/getchartdata/" + commons.collection, //$scope.values["_id"],
        //                 //transformRequest: transformRequestAsFormPost,
        //                 data: newAggregation
        //             });
        //
        //             // Store the data-dump of the FORM scope.
        //             request.success(
        //                 function (html) {
        //                     $log.log("Post updated" + html);
        //                     $scope.visualizeConfig.series.push(html);
        //                     $scope.$broadcast('highchartsng.reflow');
        //                 });
        //
        //             request.error(errCallback);
        //         }
        //     });
        //
        //     return;
        //
        // }
        //
        if (params !== null) {
            $scope.error = params.message;

        }

    }])
    .directive('smartDuallistbox', function () {
        return {
            restrict: 'A',
            link: function (scope, tElement, tAttributes) {
                tElement.removeAttr('smart-duallistbox data-smart-duallistbox');


                let aOptions = _.pick(tAttributes, ['nonSelectedFilter']);

                let options = _.extend(aOptions, {
                    nonSelectedListLabel: 'Non-selected',
                    selectedListLabel: 'Selected',
                    preserveSelectionOnMove: 'moved',
                    moveOnSelect: false
                });

                tElement.bootstrapDualListbox(options);
                //$compile(element.contents())(scope);
            }
        };
    })
    .controller('GridController', ['$scope', 'pageService', '$http', '$routeParams', 'CS', function ($scope, pageService, $http, $routeParams, CS) {
        const collection = $routeParams.collection;

        // console.log(CS);
        // console.log(document.getElementById('aggrid'));

        // const App = () => {
        //     const [rowData] = React.useState([
        //         {make: "Toyota", model: "Celica", price: 35000},
        //         {make: "Ford", model: "Mondeo", price: 32000},
        //         {make: "Porsche", model: "Boxster", price: 72000}
        //     ]);

        //     const [columnDefs] = React.useState([
        //         { field: 'make' },
        //         { field: 'model' },
        //         { field: 'price' }
        //     ])

        //     return (
        //         <div className="ag-theme-alpine" style={{height: "90vh", width: "100%"}}>
        //             <AgGridReact
        //                 rowData={rowData}
        //                 columnDefs={columnDefs}>
        //             </AgGridReact>
        //         </div>
        //     );
        //  };

        //  render(<CS.Grid />, document.getElementById('aggrid'));

        // const datasource = {
        //     getRows(params) {
        //         console.log(JSON.stringify(params.request, null, 1));

        //         $http.get(`/o/recs/${collection}?_search=false&nd=${new Date().getTime()}&rows=25&page=${params.request.endRow / 25}&sidx=updated_on&sord=desc&project=`).then(function (response) {
        //             if (response.status === 200 && response.data.rows.length > 0) {
        //                 $scope.rowCount = response.data.rows.length;
        //                 params.successCallback(response.data.rows, response.data.page);
        //             } else {
        //                 params.failCallback();
        //             }
        //         });
        //     }
        // };

        // function onModelUpdated() {
        //     var model = $scope.gridOptions.api.getModel();
        //     var totalRows = $scope.gridOptions.rowData.length;
        //     var processedRows = model.getRowCount();
        //     $scope.rowCount = processedRows.toLocaleString() + ' / ' + totalRows.toLocaleString();
        // }

        // function isFirstColumn(params) {
        //     var displayedColumns = params.columnApi.getAllDisplayedColumns();
        //     return displayedColumns[0] === params.column;
        // }

        // $scope.gridOptions = {
        //     columnDefs: [],
        //     rowData: [],
        //     rowSelection: 'multiple',
        //     // rowMultiSelectWithClick: true,
        //     rowModelType: 'serverSide',
        //     // onModelUpdated: onModelUpdated,
        //     suppressRowClickSelection: true,
        //     pagination: true,
        //     // 10 rows per page (default is 100)
        //     paginationPageSize: 25,
        //     // fetch 10 rows per block as page size is 10 (default is 100)
        //     cacheBlockSize: 25,

        //     animateRows: true,
        //     rowGroupPanelShow: 'always',
        //     // pivotPanelShow: 'always',
        //     serverSideStoreType: 'partial',
        //     enableRangeSelection: true,
        //     enableFillHandle: true,
        //     defaultColDef: {
        //         editable: true,
        //         enableRowGroup: true,
        //         // enablePivot: true,
        //         // enableValue: true,
        //         sortable: true,
        //         resizable: true,
        //         // filter: true,
        //         headerCheckboxSelection: isFirstColumn,
        //         checkboxSelection: isFirstColumn,
        //         flex: 1,
        //         minWidth: 100,
        //         // floatingFilter: true,
        //         // suppressKeyboardEvent: params => params.editing,
        //         _collection: collection
        //     },
        //     onCellValueChanged(event) {
        //         var data = event.data;
        //         console.log(data);
        //     },
        //     onRangeSelectionChanged(event) {

        //         var cellRanges = $scope.gridOptions.api.getCellRanges();
        //         cellRanges.forEach(function (range) {
        //             // get starting and ending row, remember rowEnd could be before rowStart
        //             var startRow = Math.min(range.startRow.rowIndex, range.endRow.rowIndex);
        //             var endRow = Math.max(range.startRow.rowIndex, range.endRow.rowIndex);
        //             console.log(endRow);
        //             // for (var rowIndex = startRow; rowIndex <= endRow; rowIndex++) {
        //             //     range.columns.forEach(function (column) {
        //             //         var rowModel = api.getModel();
        //             //         var rowNode = rowModel.getRow(rowIndex);
        //             //         var value = api.getValue(column, rowNode);
        //             //         if (typeof value === 'number') {
        //             //             sum += value;
        //             //         }
        //             //     });
        //             // }
        //         });
        //     },
        //     onGridReady: function (params) {

        //         pageService.getgridmodel(collection, "", "", function (_data) {

        //             const gridRenderer = new GridRenderer(collection);
        //             const columnDefs = [];
        //             async.each(_data.columnData, function (col, cb) {

        //                     // totalColumnWidth += parseInt(col.width);

        //                     if (col.name === "created_by" || col.name === "updated_by" || col.name === "updated_on" || col.name === "created_on") {
        //                         col.editable = false;
        //                     }

        //                     if (col.name === "updated_by") {
        //                         col.rowGroup = true;
        //                     }

        //                     const _val = {};
        //                     // _val.id = val._id;
        //                     _val.field = col.name;
        //                     _val.headerName = col.label;
        //                     _val.cellRenderer = gridRenderer.generalFormatter;
        //                     _val.minWidth = col.width;
        //                     _val.sortable = true;
        //                     _val.editable = col.editable;
        //                     _val.selectable = true;
        //                     _val.input_type = col.input_type;
        //                     _val.refer_collection = col.refer_collection;

        //                     function removeSpaces(str) {
        //                         return str ? str.replace(/\s/g, '') : str;
        //                     }

        //                     const countryCellRenderer = (params) => {
        //                         if (params.value === '(Select All)') {
        //                             return params.value;
        //                         }

        //                         return (
        //                             '<span>' +
        //                             params.valueFormatted +
        //                             '</span>'
        //                         );
        //                     };
        //                     //(typeof params.value === "object") ? params.value.name : params.value;
        //                     switch (col.input_type) {
        //                         case "number":
        //                             _val.cellEditor = 'agPopupTextCellEditor';
        //                             columnDefs.push(_val);
        //                             cb();
        //                             break;

        //                         case "text":
        //                             _val.cellEditor = 'agPopupTextCellEditor';
        //                             columnDefs.push(_val);
        //                             cb();
        //                             break;

        //                         case "date":
        //                             _val.cellRenderer = gridRenderer.dateFormatter;
        //                             _val.cellEditor = "dateEditor";
        //                             _val.filter = "agDateColumnFilter";
        //                             _val.valueFormatter = params => {
        //                                 return '£' + params.value;
        //                             };
        //                             _val.filterParams = {
        //                                 clearButton: true,
        //                                 suppressAndOrCondition: true,
        //                                 browserDatePicker: true,
        //                                 maxValidYear: 2021,
        //                                 comparator: function (filterLocalDateAtMidnight, cellValue) {
        //                                     var dateParts = cellValue.split("/");
        //                                     var cellDate = new Date(
        //                                         Number(dateParts[2]),
        //                                         Number(dateParts[1]) - 1,
        //                                         Number(dateParts[0])
        //                                     );
        //                                     if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
        //                                         return 0;
        //                                     }
        //                                     if (cellDate < filterLocalDateAtMidnight) {
        //                                         return -1;
        //                                     }
        //                                     if (cellDate > filterLocalDateAtMidnight) {
        //                                         return 1;
        //                                     }
        //                                 }
        //                             };
        //                             columnDefs.push(_val);
        //                             cb();
        //                             break;

        //                         case "datetime":
        //                             _val.cellRenderer = gridRenderer.dateTimeFormatter;
        //                             _val.cellEditor = "dateEditor";
        //                             _val.valueFormatter = params => {
        //                                 return '£' + params.value;
        //                             };
        //                             _val.filter = "agDateColumnFilter";
        //                             _val.filterParams = {
        //                                 clearButton: true,
        //                                 suppressAndOrCondition: true,
        //                                 browserDatePicker: true,
        //                                 maxValidYear: 2021,
        //                                 comparator: function (filterLocalDateAtMidnight, cellValue) {
        //                                     var dateParts = cellValue.split("/");
        //                                     var cellDate = new Date(
        //                                         Number(dateParts[2]),
        //                                         Number(dateParts[1]) - 1,
        //                                         Number(dateParts[0])
        //                                     );
        //                                     if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
        //                                         return 0;
        //                                     }
        //                                     if (cellDate < filterLocalDateAtMidnight) {
        //                                         return -1;
        //                                     }
        //                                     if (cellDate > filterLocalDateAtMidnight) {
        //                                         return 1;
        //                                     }
        //                                 }
        //                             };
        //                             columnDefs.push(_val);
        //                             cb();
        //                             break;

        //                         case "mselect":
        //                             columnDefs.push(_val);
        //                             cb();
        //                             break;

        //                         case "image":
        //                             columnDefs.push(_val);
        //                             break;

        //                         case "option":
        //                             let modifiedValues = [];
        //                             _val.cellEditor = 'agRichSelectCellEditor';
        //                             _val.cellRenderer = countryCellRenderer;
        //                             _val.refData = col.editoptions.value;
        //                             modifiedValues = Object.keys(col.editoptions.value);
        //                             _val.cellEditorParams = {
        //                                 cellRenderer: countryCellRenderer,
        //                                 values: modifiedValues,
        //                             };
        //                             _val.filter = 'agSetColumnFilter';
        //                             _val.filterParams = {
        //                                 values: params => {
        //                                     // async update simulated using setTimeout()
        //                                     params.success(modifiedValues);
        //                                 }
        //                             };
        //                             columnDefs.push(_val);
        //                             cb();
        //                             break;

        //                         case "checkbox":
        //                             columnDefs.push(col);
        //                             cb();
        //                             break;

        //                         case "tarea":
        //                             _val.cellEditor = 'agLargeTextCellEditor';
        //                             // _val.cellEditorParams: {
        //                             //  row,cols,maxLength
        //                             // }
        //                             columnDefs.push(col);
        //                             cb();
        //                             break;

        //                         case "gselect":
        //                             _val.cellRenderer = gridRenderer.gselectFormatter;
        //                             columnDefs.push(_val);
        //                             cb();
        //                             break;

        //                         case "url":
        //                             columnDefs.push(_val);
        //                             cb();
        //                             break;

        //                         case "code":
        //                             columnDefs.push(_val);
        //                             cb();
        //                             break;

        //                         case "password":
        //                             columnDefs.push(_val);
        //                             cb();
        //                             break;

        //                         default:
        //                             cb();

        //                     }
        //                 },

        //                 function (err) {
        //                     if (err) {
        //                         throw err;
        //                     }
        //                     columnDefs[0].cellRenderer = (collection === 'fs.files') ? gridRenderer.fileviewNewWindow : gridRenderer.returnHyperLink;
        //                     // columnDefs[0].pinned = true;
        //                     columnDefs[0].checkboxSelection = true;
        //                     columnDefs[0].headerCheckboxSelection = true;
        //                     //     columnDefs[0].headerCheckboxSelectionFilteredOnly= true;
        //                     //     columnDefs[0].checkboxSelection= true;
        //                     // columnDefs.unshift({
        //                     //     headerName: '',
        //                     //     width: 40,
        //                     //     checkboxSelection: true,
        //                     //     sortable: false,
        //                     //     suppressMenu: true,
        //                     //     // pinned: true
        //                     // });

        //                     // columnDefs.push({
        //                     //     headerName: "",
        //                     //     colId: "actions",
        //                     //     cellRenderer: "actionsRenderer",
        //                     //     editable: false,
        //                     //     filter: false,
        //                     //     minWidth: 220
        //                     // });
        //                     params.api.setColumnDefs(columnDefs);
        //                     // params.api.setRowData(response.data.rows);
        //                     params.api.sizeColumnsToFit();
        //                     params.api.setServerSideDatasource(datasource);

        //                     $scope.exportCSV = () => {
        //                         $scope.gridOptions.api.exportDataAsCsv({});
        //                     };
        //                 });
        //         });
        //     }
        // };

    }]);

